import { qrcodeKeys } from './constants'

import { createEventEmitter } from '../event'

export const qrcodeEventEmitter = createEventEmitter()

export const emitOpenQRCodeModal = () => {
    qrcodeEventEmitter.emit(qrcodeKeys.SHOW_QR_CODE)
}
